export const VIEWPORT = {
  xs: 0,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
}

export const VIEWPORT_SIZES = {
  xs: 320,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
}
